var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import Button from '@storeblocks/button';
import { Icon } from '@storeblocks/icon';
import { LargeCardBase, Graphic, Content, Title, Caption, Description, Actions, Overline, } from './styled';
export function LargeCard(_a) {
    var { id, overline, title, caption, description, actions, icon, image, alt } = _a, props = __rest(_a, ["id", "overline", "title", "caption", "description", "actions", "icon", "image", "alt"]);
    if (icon && image) {
        throw new Error(`
      Cannot set both icon and image simultaneously!
      Pick one!
    `);
    }
    const renderActions = useCallback(() => (actions === null || actions === void 0 ? void 0 : actions.length) !== 0 && (React.createElement(Actions, null, actions === null || actions === void 0 ? void 0 : actions.map((_a) => {
        var { text } = _a, actionProps = __rest(_a, ["text"]);
        return (React.createElement(Button, Object.assign({ as: "a", variant: "text", iconRight: "arrow-right", key: `large-card-${text}` }, actionProps), text));
    }))), [actions]);
    const renderGraphic = useCallback(() => (icon || image) && (React.createElement(Graphic, null,
        icon && React.createElement(Icon, { name: icon }),
        image && React.createElement("img", { src: image, alt: alt }))), [alt, icon, image]);
    return (React.createElement(LargeCardBase, Object.assign({ id: id }, props),
        renderGraphic(),
        React.createElement(Content, null,
            React.createElement(Overline, null, overline),
            React.createElement(Title, null, title),
            caption && React.createElement(Caption, null, caption),
            description && React.createElement(Description, null, description)),
        renderActions()));
}
export default LargeCard;
